import { OpenAiImageTestPage } from "@/features/smile-simulation/components/OpenAiImageTestPage";
import { SmileSimulationScreen } from "@/features/smile-simulation/components/SmileSimulationScreen";

const EXPERIENCE_PATH_PREFIX = "/experience";
const OPENAI_TEST_PATH = "/openai-image-test";

const isExperiencePath = (pathname: string) =>
  pathname === EXPERIENCE_PATH_PREFIX ||
  pathname.startsWith(`${EXPERIENCE_PATH_PREFIX}/`);

function ExperienceSmileSimulationPage() {
  return <SmileSimulationScreen allowUnauthenticated isExperience />;
}

export function App() {
  if (import.meta.env.DEV && window.location.pathname === OPENAI_TEST_PATH) {
    return <OpenAiImageTestPage />;
  }

  if (isExperiencePath(window.location.pathname)) {
    return <ExperienceSmileSimulationPage />;
  }

  return <SmileSimulationScreen />;
}
